import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { IModel } from '../../base/annotation';
import { Metamodel } from 'app/model/base/model';
import { AmazonS3CompatibleLinkedService } from 'app/model/linkedservice/amazon-s3-compatible.linkedservice';
import { LinkedServiceAdapter } from 'app/model/adapters/linkedservices/linkedservice.adapter';
import { ValueAdapter } from 'app/model/adapters/value.adapter';
import {
    parameterizableSecretBaseToModel,
    parameterizablePasswordOrAKVtoSecretBase,
    parameterizableTextOrAKVtoValue,
    parameterizableValueToModel
} from 'app/model/adapters/linkedservices/azure-key-vault.util';

@AdapterRegistry.adapter({
    model: Metamodel.modelFor(AmazonS3CompatibleLinkedService),
    asynchronous: true,
    adapts: {
        name: '*',
        properties: {
            description: '*',
            type: '*',
            connectVia: '*',
            typeProperties: {
                serviceUrl: '*',
                // Do not add this as a func, otherwise accessKeyId will be put into raw after being processed in ValueAdapter.remainder
                accessKeyId: 'akv',
                secretAccessKey: 'secret',
                encryptedCredential: '*',
                forcePathStyle: '*'
            },
            parameters: '*'
        }
    }
})
export class AmazonS3CompatibleLinkedServiceAdapter extends LinkedServiceAdapter<AmazonS3CompatibleLinkedService> {
    protected supportFirstClassParameterExperience = true;

    protected modelConstructor(): new () => AmazonS3CompatibleLinkedService {
        return AmazonS3CompatibleLinkedService;
    }

    protected model(): IModel {
        return AmazonS3CompatibleLinkedService.MODEL;
    }

    protected async propertiesToResourceAsync(linkedService: AmazonS3CompatibleLinkedService, linkedServiceResource: Model.LinkedServiceResource): Promise<Model.LinkedServiceResource> {
        const properties = this.properties(linkedServiceResource) as Model.AmazonS3CompatibleLinkedService;

        properties.type = Metamodel.modelFor(AmazonS3CompatibleLinkedService).name;
        properties.typeProperties = {
            serviceUrl: this.valueToResource(linkedService, AmazonS3CompatibleLinkedService.SERVICE_URL),
            accessKeyId: parameterizableTextOrAKVtoValue(linkedService, AmazonS3CompatibleLinkedService.ACCESS_KEY_ID, this.context),
            secretAccessKey: parameterizablePasswordOrAKVtoSecretBase(linkedService, AmazonS3CompatibleLinkedService.ACCESS_KEY, this.context),
            forcePathStyle: this.valueToResource(linkedService, AmazonS3CompatibleLinkedService.FORCE_PATH)
        };

        return linkedServiceResource;
    }

    protected async propertiesToModelAsync(linkedServiceResource: Model.LinkedServiceResource, linkedService: AmazonS3CompatibleLinkedService): Promise<AmazonS3CompatibleLinkedService> {
        const properties = linkedServiceResource.properties as Model.AmazonS3CompatibleLinkedService;
        ValueAdapter.toModel(linkedService, AmazonS3CompatibleLinkedService.SERVICE_URL, properties.typeProperties.serviceUrl);
        parameterizableValueToModel(linkedService, AmazonS3CompatibleLinkedService.ACCESS_KEY_ID, properties.typeProperties.accessKeyId, this.context);
        parameterizableSecretBaseToModel(linkedService, AmazonS3CompatibleLinkedService.ACCESS_KEY, properties.typeProperties.secretAccessKey, this.context);
        ValueAdapter.toModel(linkedService, AmazonS3CompatibleLinkedService.FORCE_PATH, properties.typeProperties.forcePathStyle);

        return linkedService;
    }
}
